module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_xc60@2x-ffe8d4ed8d04efbfc339595b9f3a9911.png";